module.exports = __webpack_public_path__ + "img/extra_night_rate.5f63664c.svg";